
function showHideNextP(div,plusMinus,set) {
  var x = div;
  if(set==undefined) {
  	if (x.style.display === "none") {
      set=true;
    } else {
      set=false;
    }
  }
  if (set) {
    x.style.display = "block";
    plusMinus.innerHTML='+';
  } else {
    x.style.display = "none";
    plusMinus.innerHTML='-';
  }
}

function setupShowHideP(div,plusMinus) {
	plusMinus.parentNode.addEventListener('click',function() {
		showHideNextP(div,plusMinus);
	});
}

if(/faqs$/.exec(location.href) || document.getElementById('FAQ')) {
  //var template_page=document.getElementsByClassName('template_page')[0];
  var template_page = document.getElementById('FAQ');
  var strongs=template_page.getElementsByTagName('strong');
  for(var s=0; s<strongs.length; ++s) {
      var strong=strongs[s];
    if(strong.parentNode.tagName.toUpperCase()!='P') 
      continue;
    var parent=strong.parentNode;
    parent.className='FaqLink';
    parent.style.cursor='pointer';
    
      var divToShow=strong.parentNode.nextElementSibling;
    	if(!divToShow) continue;
    divToShow.style.display='none';
      var plusMinus=document.createElement('font');
      plusMinus.innerHTML='-';
    plusMinus.style.paddingRight="10px";
    
      strong.parentNode.insertBefore(plusMinus,strong);
      setupShowHideP(divToShow,plusMinus);
  }
}












  const mapLink = document.querySelector('#map-link');
function geoFindMe() {

  const status = document.querySelector('#map-link-status');

  mapLink.href = '';
  mapLink.textContent = '';

  function success(position) {
    const latitude  = position.coords.latitude;
    const longitude = position.coords.longitude;

	//"https://www.google.com/maps/d/embed?mid=1Ft2kpZ6WnJIL1sK7UrCQKzpoPWODKbvq&ll=-33.8569%2C151.2152&z=6"
	var url="https://www.google.com/maps/d/embed?mid=1Ft2kpZ6WnJIL1sK7UrCQKzpoPWODKbvq&ll="+latitude+","+longitude+"&z=12";
    status.textContent = '';
    mapLink.src = url;
  }

  function error() {
    status.textContent = 'Unable to retrieve your location';
  }

  if (!navigator.geolocation) {
    status.textContent = 'Geolocation is not supported by your browser';
  } else {
    status.textContent = 'Locating…';
    navigator.geolocation.getCurrentPosition(success, error);
  }

}

if(mapLink)
	geoFindMe();



function zoom(e){
  var zoomer = e.currentTarget;
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

//////////////////////




// banner videos
var banner_upto=0;
const rotate_banners = document.getElementById('rotate_banners');
if(rotate_banners) {
  const bannerElems=rotate_banners.getElementsByClassName('FrontPageBanner');
  var banners=[];
  
  for(const bannerElem of bannerElems) {
    var waitMS=bannerElem.getAttribute('data-waitms');
    banners.push([bannerElem, waitMS, null]);
    bannerElem.addEventListener('click',function() {
      const url=this.getAttribute('data-url');
      if(url)
        location.href=url;
    });
    if(!waitMS) {
      bannerElem.addEventListener('ended',function() {
        halloween();
      });
    }
  }
  banners.push(    [document.getElementById('whatis_banner'), 10000, document.getElementById('banner_txt')]);
  function halloween() {
    if(banners.length<=1 || !banners[0][0] || !banners[1][0]) {
      // not on front page
      return;
    }
    for(var b=0; b<banners.length; ++b) {
      var d=(b==banner_upto);
      var disp=d?'':'none';
      banners[b][0].style.display=disp;
      var alt_elem=banners[b][2];
      if(alt_elem) {
        alt_elem.style.display=disp;
      }
      var banner=banners[b][0];
      if(banner.tagName=='VIDEO') {
        if(d) {
          banner.currentTime=0;
          banner.load();
        } else { 
          banner.pause();
        }
      }
    }
    var current_banner=banners[banner_upto];
    
    ++banner_upto;
    banner_upto=(banner_upto%banners.length);
    
    if(current_banner[1]) {
      setTimeout(function() {
        halloween();
      },current_banner[1]);
    }
  }
  halloween();
}

/*
// halloween banner imgs
var banner_upto=0;
function halloween() {
  const bannerElems=document.getElementById('rotate_banners').getElementsByClassName('FrontPageBanner');
  var banners=[];
  for(const bannerElem of bannerElems) {
    var waitMS=bannerElem.getAttribute('data-waitms');
    console.log(waitMS);
    if(!waitMS)
      waitMS=10000;
    banners.push([bannerElem, waitMS, null]);
  }
  banners.push(    [document.getElementById('whatis_banner'), 10000, document.getElementById('banner_txt')]);

  if(banners.length<=1 || !banners[0][0] || !banners[1][0]) {
    // not on front page
    return;
  }
//console.log(banners);  
  for(var b=0; b<banners.length; ++b) {
    var disp=(b==banner_upto)?'':'none';
    banners[b][0].style.display=disp;
    var alt_elem=banners[b][2];
    if(alt_elem)
      alt_elem.style.display=disp;
  }
  var current_banner=banners[banner_upto];
  
  ++banner_upto;
  banner_upto=(banner_upto%banners.length);
  
  setTimeout(function() {
    halloween();
  },current_banner[1]);
}
halloween();
  */    


//////////////////////
